import { Routes, Route } from "react-router-dom";

import LoginPage from "./pages/Login";
import TrackersPage from "./pages/Trackers";
import TrackerPage from "./pages/Tracker";
import TrackersBulkRedirectPage from './pages/TrackersBulkRedirect';

import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./hooks/useAuth";

import './app.scss';
import 'react-tooltip/dist/react-tooltip.css'

import fontawesome from '@fortawesome/fontawesome'
import packFree from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(packFree);

function App() {
    return (
        <AuthProvider>
            <Routes>
                <Route
                    path="/"
                    element={
                            <LoginPage />
                        }
                    />
                <Route
                    path="/trackers"
                    element={
                            <ProtectedRoute>
                                <TrackersPage />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/trackers/redirect"
                    element={
                            <ProtectedRoute>
                                <TrackersBulkRedirectPage />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/tracker/:id"
                    element={
                            <ProtectedRoute>
                                <TrackerPage />
                            </ProtectedRoute>
                        }
                    />
            </Routes>
        </AuthProvider>
    );
}

export default App;
